import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message"];
import { sendMessageRpc as pollingSendMessageRpc, sendMessagesRpc as pollingSendMessagesRpc, sendToolResponseRpc as pollingSendToolResponseRpc, sendToolApprovalRpc as pollingSendToolApprovalRpc, cancelTurnRpc as pollingCancelTurnRpc, getTurnResultRpc, submitFeedbackRpc } from '../../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineService';
import { createDefaultChirpClient } from '../chirpClient';
import { hasLocalAgentRoute, prepareAndEnqueueLocalSendMessage, prepareAndEnqueueLocalSendMessages, prepareAndEnqueueLocalToolResponse } from '../localAgent';
let defaultPollingClient = null;
function getDefaultPollingClient() {
  if (!defaultPollingClient) {
    defaultPollingClient = createDefaultChirpClient();
  }
  return defaultPollingClient;
}
export function createPollingBreezeConnection(chirpClient) {
  const client = chirpClient !== null && chirpClient !== void 0 ? chirpClient : getDefaultPollingClient();
  const localConversationIds = new Set();
  return {
    async sendMessage(request) {
      // The only place we branch on the string-vs-blocks shape: pick the right
      // CHIRP RPC + local-prepare RPC. Everything above this point (chatClient,
      // transport) pipes the union through unchanged.
      const {
          message
        } = request,
        common = _objectWithoutPropertiesLoose(request, _excluded);
      const isLocal = await hasLocalAgentRoute(request.agentId);
      let response;
      if (typeof message === 'string') {
        const chirpRequest = Object.assign({}, common, {
          message
        });
        response = isLocal ? await prepareAndEnqueueLocalSendMessage(client, chirpRequest) : await client.call(pollingSendMessageRpc, {
          request: chirpRequest
        });
      } else {
        const chirpRequest = Object.assign({}, common, {
          contentBlocks: message
        });
        response = isLocal ? await prepareAndEnqueueLocalSendMessages(client, chirpRequest) : await client.call(pollingSendMessagesRpc, {
          request: chirpRequest
        });
      }
      if (isLocal) {
        localConversationIds.add(response.conversationId);
      }
      return response;
    },
    async sendToolResponse(request) {
      if (localConversationIds.has(request.conversationId)) {
        return prepareAndEnqueueLocalToolResponse(client, request);
      }
      return await client.call(pollingSendToolResponseRpc, {
        request
      });
    },
    async sendToolApproval(request) {
      return await client.call(pollingSendToolApprovalRpc, {
        request
      });
    },
    async cancelTurn(request) {
      return await client.call(pollingCancelTurnRpc, {
        request
      });
    },
    async getTurnResult(request) {
      return await client.call(getTurnResultRpc, {
        request
      });
    },
    async submitFeedback(request) {
      return await client.call(submitFeedbackRpc, {
        request
      });
    }
  };
}